class EnumService {
  getPropertyImportTypes(t) {
    return [
      { label: t('propertyImports.creation'), value: true },
      { label: t('propertyImports.deletion'), value: false },
    ];
  }
}

const enumService = new EnumService();
export default enumService;
